import { useState } from 'react';

const useSpeechRecService = () => {
  const [transcription, setTranscription] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;  

  const transcribeAudio = async (audioContent: string) => {
    try {
      const response = await fetch(
        `https://speech.googleapis.com/v1/speech:recognize?key=${apiKey}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            config: {
              languageCode: 'pt-BR',
              encoding: 'LINEAR16',
              sampleRateHertz: 41000,
            },
            audio: {
              content: audioContent,
            },
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Erro na transcrição: ${response.statusText}`);
      }

      const data = await response.json();
      if (data.results && data.results.length > 0) {
        setTranscription(data.results[0].alternatives[0].transcript);
        return data;
      } else {
        setTranscription(null);
        return null;
      }
    } catch (err: any) {
      setError(err.message);
    }
  };

  return { transcribeAudio, transcription, error };
};

export default useSpeechRecService;
